import { ProFormColumnsType } from '@ant-design/pro-components';
import { createCurrencyFormItem } from '../createCurrencyFormItem';
import { createNumberFormItem, createTextFormItem } from './createTextFormItem';

export const companyDirectorFormSchema = (): ProFormColumnsType[] => [
  {
    valueType: 'group',
    columns: [
      ...['companyName', 'occupation'].map(item => createTextFormItem(item, 'member.income')),
      ...['timeTrading'].map(item => createNumberFormItem(item, 'member.income', 1)),
      ...['salaryMostRecentYear', 'dividendsMostRecentYear', 'salaryPriorYear', 'dividendsPriorYear'].map(item =>
        createCurrencyFormItem(null, item, 'member.income', undefined, true),
      ),
    ],
  },
];
